import { Navigate, Outlet } from 'react-router';

import { useSession } from './session';

/** Where the onboarding step that creates the account (NPI confirmation) lives. */
export const ONBOARDING_NPI_PATH = '/onboarding/npi';

const loginRedirect = (expired: boolean) => (expired ? '/login?reason=session_expired' : '/login');

/** Routes for people with a portal account. Without a session: login. Without an account yet: the NPI step. */
export const RequireAccount = () => {
  const session = useSession();
  switch (session.status) {
    case 'loading':
      return null;
    case 'signed-out':
      return (
        <Navigate
          to={loginRedirect(session.expired)}
          replace
        />
      );
    case 'needs-account':
      return (
        <Navigate
          to={ONBOARDING_NPI_PATH}
          replace
        />
      );
    case 'signed-in':
      return <Outlet />;
  }
};

/** The onboarding steps before the account exists. Once it does, they are done: go to the dashboard. */
export const RequireNoAccount = () => {
  const session = useSession();
  switch (session.status) {
    case 'loading':
      return null;
    case 'signed-out':
      return (
        <Navigate
          to={loginRedirect(session.expired)}
          replace
        />
      );
    case 'needs-account':
      return <Outlet />;
    case 'signed-in':
      return (
        <Navigate
          to="/"
          replace
        />
      );
  }
};
